import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AppVersionService} from '../app-version.service';
import {takeUntil, delay} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {AppVersion} from '../app-version.model';
import {AuthService} from '../../../auth/auth.service';
import {SwUpdate} from '@angular/service-worker';

@Component({
  selector: 'qm-app-version-notifier',
  templateUrl: './app-version-notifier.component.html',
  styleUrls: ['./app-version-notifier.component.scss']
})
export class AppVersionNotifierComponent implements OnInit, OnDestroy {

  @ViewChild('updateModal', { static: true }) updateModal: ElementRef;
  public availableVersion: AppVersion;
  public counter: number = 0;
  public counterText: string;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private modalService: NgbModal,
    private updates: SwUpdate,
    private appVersionService: AppVersionService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.appVersionService.appUpdates$.pipe(
      takeUntil(this.ngUnsubscribe),
      // to prevent too many concurrent refreshes, delay by up to a minute
      delay(Math.random() * 1000 * 60),
      // extra takeUntil needed to ensure subscriptions don't trigger after the component's destruction; required for tests
      takeUntil(this.ngUnsubscribe)
    ).subscribe((data) => {
      console.log('NEW APP VERSION', data);
      this.availableVersion = data;
      const tenantId = this.auth.getTenant();
      this.open(this.updateModal);
      if (this.availableVersion.forcedUpdate) {
        const iv = setInterval(() => {
          this.counter++;
          if (this.counter <= 60) {
            let v: string | number = (60 - this.counter);
            if (v < 10) {
              v = '0' + v;
            }
            this.counterText = '01:' + v;
          } else {
            let v: string | number = (120 - this.counter);
            if (v < 10) {
              v = '0' + v;
            }
            this.counterText = '00:' + v;
          }
          if (this.counter > 120) {
            clearInterval(iv);
            this.update();
          }
        }, 1000);
      }
    });
  }

  /**
   * Angular destructor hook
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public open(content): Promise<void> {
    const modal = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', keyboard: false});
    return modal.result.then(() => {
      this.update();
    }, () => {
      // modal was dismissed; do nothing
    });
  }

  private update(): void {
    if (this.availableVersion.resetCache) {
      localStorage.clear();
    }
    this.updates.activateUpdate().then(() => window.location.reload());
  }
}
